var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _c(
      "div",
      { staticClass: "order bs" },
      [
        _c("order-nav-bar", {
          attrs: { "product-name": _vm.state.productName },
        }),
        _vm._v(" "),
        _c("router-view"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }